export default __webpack_public_path__ + "static/media/clientOne.ded413b9.jpg";